import { StrapiActions, StrapiActionTypes, StrapiState } from "../../types/strapiGOS";

const initialState: StrapiState = {};

export const filtersDataGOS = (state = initialState, action: StrapiActions): StrapiState => {
  switch (action.type) {
    case StrapiActionTypes.FETCH_REQUEST_GOS: {
      const { modelName } = action.payload;
      return {
        ...state,
        [modelName]: {
          data: state[modelName]?.data || [],
          loading: true,
          error: null,
        },
      };
    }

    case StrapiActionTypes.FETCH_SUCCESS_GOS: {
      const { modelName, data, pagination, append } = action.payload;
      const existingData = state[modelName]?.data || [];
      return {
        ...state,
        [modelName]: {
          data: append ? [...existingData, ...data] : data,
          loading: false,
          error: null,
          pagination,
        },
      };
    }

    case StrapiActionTypes.FETCH_FAILURE_GOS: {
      const { modelName, error } = action.payload;
      return {
        ...state,
        [modelName]: {
          data: state[modelName]?.data || [],
          loading: false,
          error,
        },
      };
    }

    default:
      return state;
  }
};
